import {
  onSortData,
  multiFilterChange,
  getModifiedDSBPScreenHeaderNames,
  checkIfOrderSame
} from "../../utils";
import moment from "moment";
import _, { isEmpty } from "lodash";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import DSBPScreenHeader from "./DSBPScreenHeader";
import DSBPScreenNameHeader from "./DSBPScreenNameHeader";
import LoadingOverlay from "react-loading-overlay-ts";
import { changeDateFormat } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ProjectService } from "../../service/PegaService";
import CustomizeView from "../common/CustomizeView";
import Footer from "../common/tableFooter/tableFooter";
import ACPFilter from "../ACP/common/ACPFilter";
import { AcpService } from "../../service/ACPService";
import { AcpCommonService } from "../../service/AcpCommonService";
import { getColumnsOrder, setColumnsOrder } from "../../apis/commonApi";
import { localWidthStorage } from "../../utils";
import DsbpCommonPopup from "../DSBP/DsbpCommonPopup";
import { createNewProject } from "../../apis/projectSetupApi";
import { addDsbpToProject } from "../../apis/dsbpApi";
import { Toast } from 'primereact/toast';
import { SpecialProjectAction } from "../../store/actions/ProjectSetupActions";

const DSBPScreenList = (props) => {
  const flag = props.flag;
  const op = useRef(null);
  const dt = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const filterArray = useRef([]);
  const colAllSelected = useRef([]);
  const currentUrl = (location.pathname).replace("/dsbpScreen", "/allProjects");
  const selectedFieldsRef = useRef([]);
  const selectedColumnList = useRef([]);
  const toast = useRef(null);
  const [filters, setFilters] = useState([]);
  const [loader, setLoader] = useState(false);
  const [sortData, setSortData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [pegadata, setPegaData] = useState(null);
  const [isSearch, isSearchSet] = useState(false);
  const [isColWidthSet, setColWidth] = useState(null);
  const [frozenCoulmns, setFrozenColumn] = useState([]);
  const [tableRender, setTableRender] = useState(false);
  const [selectedFields, setSelectedFields] = useState({});
  const [allColumnNames, setAllColumnNames] = useState([]);
  const [ProjectFrozen, setProjectFrozen] = useState(false);
  const [filterCleared, setFilterCleared] = useState(false);
  const [initialPegaData, setInitialPegaData] = useState(null);
  const [ProjectData, setProjectData] = useState(0);
  
  const [isReorderedColumn, setReorderedColumn] = useState(false);
  const [projectColumnName, setProjectColumnNames] = useState([]);
  const [selectedColumnName, setSelectedColumnName] = useState(null);
  const [customizeViewFields, setCustomizeViewFields] = useState([]);
  const [updatedAllColumnNames, setUpdatedAllColumnNames] = useState([]);
  const [initialColumnLenght, setinitialColumnLenght] = useState({});
  const [resizeMode, setResizeMode] = useState("expand");
  const StorageData = localStorage.getItem("customizeViewFieldsDSBPScreen");
  const customizeViewFieldsStorage = StorageData && JSON.parse(StorageData);
  const [customViewIsAddedDSBPScreen, isCustomViewIsAddedDSBPScreen] = useState(false);
  const user_group = useSelector((state) => state?.UserDetailsReducer?.userDetails?.UserGroup);
  const [availableFields, setAvailableFields] = useState([]);
  const [datatableColumnFromPega, setDatatableColumnFromPega] = useState([]);
  const [pgDefaultColumns, setPGDefaultColumns] = useState({});
  const [DSBPCreateProjectData, setDSBPCreateProjectData] = useState({});

  const User = useSelector((state) => state?.UserReducer);
  const userInformation = User?.userInformation;


  const checkIsFilterApplied = () => {
    let isSelectedVal = false;
    if (selectedFields && Object.keys(selectedFields)?.length > 0) {
      isSelectedVal = Object.values(selectedFields)?.some((value) => value.length > 0);
    }
    return isSelectedVal;
  };
  const isFilterEnabled = isSearch || checkIsFilterApplied();

  const isResetEnabled = isFilterEnabled || customViewIsAddedDSBPScreen || frozenCoulmns.length > 0;
  const [conditionMatched, setConditionMatched] = useState(false);

  const DSBPScreenList = useSelector((state) => state.DSBPScreenReducer.DSBPScreenData);
  const [searchHeader, setSearchHeader] = useState({});
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [visibleWarningCreateProject, setVisibleWarningCreateProject] = useState(false);

  const allColumnNamesConstValue = [
    "AWMProjectID",
    "DSBP_InitiativeID",
    "DSBP_Initiative_Name",
    "Category",
    "DSBP_IL",
    "CountOfLockedPMPs",
    "CountOfPOAs",
    "Region",
    "PM",
  ];

  const getProjectCategory = (subCategories) => {
    const selectedCategoriesOptions = [];
    if (subCategories && subCategories.length > 0) {
      subCategories?.forEach((obj) => {
          let temp = {};
          temp.instruction = "APPEND";
          temp.target = "ProjectCategory";
          temp.content = {
          Category_Name: obj["Category_Name"],
          code: obj["code"],
        };
        selectedCategoriesOptions.push(temp);
      });
    }
    return selectedCategoriesOptions;
  };

  const getProjectBrand = (brand) => {
    const selectedBrandOptions = [];
    if (brand && brand.length > 0) {
        brand.forEach((obj) => {
          let temp = {};
          temp.instruction = "APPEND";
          temp.target = "ProjectBrand";
          temp.content = obj;
          selectedBrandOptions.push(temp);
      });
    }
    return selectedBrandOptions;
  };

  const DSBPConvertDateFormat = (dateString) => {
    const parsedDate = moment(dateString, "YYYYMMDD");
    const formattedDate = parsedDate.toDate();
    return formattedDate;
  };

  const formatPayloadDate = (date) => {
    if (date) {
      const formattedDate = moment(date, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format(
        "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
      );
      return formattedDate;
    } else {
      return date;
    }
  };

 const collectCreateProjectData = (status, mode, varDSBPCreateProjectData) => {
      const todaysDate = new Date();
      const loginUserID = userInformation?.userid || "";
      const ProjectCategory = getProjectCategory(varDSBPCreateProjectData.Artwork_Category_Store);
      const ProjectBrand = getProjectBrand(varDSBPCreateProjectData.Artwork_Brand_Store);
      
      const formData = {
        content: {
          BU: varDSBPCreateProjectData?.BU,
          Comments:"",
          DesignIntent: false,
          EstimatedNoOfDI:"",
          DesignTemplate: false,
          EstimatedNoOfDT:"",
          InkQualification: false,
          EstimatedNoOfIQ:"",
          NewPrintFeasibility: false,
          EstimatedNoOfNPF:"",
          ProductionReadyArt: false,
          EstimatedNoOfPRA:"",
          CICs: false,
          Estimated_ofCICs:"",
          POAs: "true",
          Estimated_ofPOAs:varDSBPCreateProjectData.CountOfPMPs,
          Estimated_SOP: "",
          Estimated_SOS: "",
          Estimated_AW_Printer:
            "DSBP_PMP_ArtworkDate" in varDSBPCreateProjectData
              ? formatPayloadDate(
                  DSBPConvertDateFormat(varDSBPCreateProjectData.DSBP_PMP_ArtworkDate),
                )
              : "",
          Estimated_AW_Readiness: formatPayloadDate(todaysDate),
          IL: varDSBPCreateProjectData.DSBP_IL,
          Project_Start_Date: formatPayloadDate(todaysDate),
          InitiativeGroupName: "",
          PM: loginUserID,
          Cluster: "",
          ProjectDescription: "",
          ProjectName: varDSBPCreateProjectData.ProjectName,
          Project_region: (varDSBPCreateProjectData?.Region?.toLowerCase() === "x-region") ? props?.xregionValue : varDSBPCreateProjectData?.Region,
          Project_Code: varDSBPCreateProjectData.Project_Code,
          Project_State: "Draft",
          Buffer_To_Work: "",
          ProjectStatus: "Draft",
          ProjectSource:"DSBP"
        },
        pageInstructions: [...ProjectCategory, ...ProjectBrand],
      };
      if (mode === "create") {
        formData.caseTypeID = "PG-AAS-Work-ArtworkProject";
      }
      return formData;
    };

  const handleCreateProjectClick = (options) => {
    setVisibleWarningCreateProject(true);
    setDSBPCreateProjectData(options);
  }

  const handleCreateProject = async () => {
    setVisibleWarningCreateProject(false);

    //setSpinnerText("Saving");
    setLoader(true);
    const mode = "create";
    if (mode === "create") { 
      let draftFormData = collectCreateProjectData("Draft", mode,DSBPCreateProjectData);
      
      localStorage.setItem("formDraft", JSON.stringify(draftFormData));
      const response = await createNewProject(draftFormData);
      let result_AWMProjectId = "";

      if (response?.data?.ID) {
         result_AWMProjectId = response?.data?.ID.split("PG-AAS-WORK ")[1];

         toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: `Project ${result_AWMProjectId} has been successfully created.`,
                life: 20000 // 20 seconds
          });

         if( result_AWMProjectId && DSBPCreateProjectData.DSBP_InitiativeID ) {
            let InitiativeID = DSBPCreateProjectData.DSBP_InitiativeID;
            let checkRes = await addDsbpToProject(result_AWMProjectId, InitiativeID);
            if(checkRes?.status === 200) {

              toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'DSBP has been successfully assigned to the project.',
                life: 20000 // 20 seconds
              });

              // Add delay before navigation to allow toast to display
              setTimeout(() => {
                navigate(`${currentUrl}/projectSetup/${result_AWMProjectId}`);
              }, 2000); // 2 second delay

            } else {
              toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to add DSBP to project. Please try again.',
                life: 20000 // 20 seconds
              });
              console.error("Failed to add DSBP to project");
            }
         }else {
         toast.current.show({
           severity: 'error',
           summary: 'Error',
           detail: 'Missing project ID or DSBP Initiative ID.',
           life: 20000 // 20 seconds
         });
       }
      } else {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to create project. Please try again.',
          life: 20000 // 20 seconds
        });
      }
      
    }
  }

  useEffect(() => clearFilter(), [DSBPScreenList])

  useEffect(() => {
    const fetchColumnFromPega = async () => {
      try {
        let datatableColumnFromPega = await getColumnsOrder(userInformation?.userid, "DSBPScreenAllColumnNames", "NA", "NA");
        if (datatableColumnFromPega != null && datatableColumnFromPega?.length > 0) {
          setDatatableColumnFromPega(datatableColumnFromPega)
        }
        else {
          let localAllColumns = localStorage.getItem("allColumnNames");
          let _allColumns = JSON.parse(localAllColumns);
          if (isEmpty(_allColumns)) {
            _allColumns = ProjectService.getDSBPScreenColumnData();
          }
          setDatatableColumnFromPega(_allColumns)
        }
      } catch (err) {
        console.log(err)
      }
    };
    if (userInformation?.userid != undefined)
      fetchColumnFromPega();
  }, [userInformation]);

  // const jsonColumnWidth = JSON.parse(columnWidth);
  useEffect(() => {
    let sortingData = JSON.parse(localStorage.getItem("sortingData"));
    if (sortingData && sortingData?.length) {
      onSort(sortingData[0], sortingData[1]);
    }
  }, []);

  useEffect(() => {
    let temp = projectColumnName?.reduce((acc, curr) => {
      let matchMode =
        selectedFields[curr] && selectedFields[curr]?.length > 0
          ? FilterMatchMode.IN
          : FilterMatchMode.CONTAINS;
      return {
        ...acc,
        [curr]: {
          value:
            selectedFields[curr] && selectedFields[curr]?.length > 0 ? selectedFields[curr] : null,
          matchMode: matchMode,
        },
      };
    }, {});

    if (globalFilterValue !== "") {
      temp["global"] = { value: globalFilterValue, matchMode: FilterMatchMode.CONTAINS };
    }
    setSearchHeader(temp);
  }, [selectedFields, globalFilterValue, projectColumnName]);

  const onGlobalFilterKeyword = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const { loading } = DSBPScreenList;
  useEffect(() => {
    if (projectColumnName.length < 6) {
      setResizeMode("fit");
    } else {
      setResizeMode("expand");
    }
  }, [projectColumnName]);

  useEffect(() => {
    const ProjectData = _.cloneDeep(DSBPScreenList);
    let allCol = [];
    if (ProjectData?.length) {
      allCol = Object.keys(ProjectData[0]);
      allCol.push("Artwork_Status");
    }
    let columnWidthDSBPScreen = {};

    let getJsonStoredWidthColumns = localStorage.getItem("columnWidthDSBPScreen");
    let getStoredWidthColumns = JSON.parse(getJsonStoredWidthColumns);
    const checkEmptyObject = _.isEmpty(getStoredWidthColumns);

    if (checkEmptyObject) {
      localStorage.setItem("columnWidthDSBPScreen", JSON.stringify(columnWidthDSBPScreen));
    }

    let jsonColWidth = localStorage.getItem("isColWidthSetDSBPScreen");
    let isColWidthSetFlag = JSON.parse(jsonColWidth);
    if (isColWidthSetFlag) {
      setColWidth(true);
    }

    let availableFields;
    const selectedFeilds = ProjectService.getDSBPScreenColumnData();
    availableFields = allColumnNames?.filter(function (objFromA) {
      return !selectedFeilds.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });
    setinitialColumnLenght({
      availableFields: availableFields.length,
      freezedColumns: 0,
      selectedFields: selectedFeilds.length,
    });
    const selectedFeildsVal = allColumnNamesConstValue
    const customizeViewFieldsUpdated = formCustomizeObject(availableFields, [], selectedFeildsVal);
    setPGDefaultColumns(customizeViewFieldsUpdated);
  }, []);

  useEffect(() => {
    if (userInformation?.userid != undefined)
    setToInitialCustomizeView();
  
    getCustomizedView();
  }, [allColumnNames,userInformation]);

  useEffect(() => {
    setLoader(true);
    (async () => { 
      try {

        //below is api call
        const ProjectData = _.cloneDeep(DSBPScreenList);

        if (ProjectData && ProjectData.length) {
          let allCol = Object.keys(ProjectData[0]);
          setAllColumnNames(reorderColumns(allCol));

          ProjectData.filter((field) => {
            if (field.Artwork_Category) {
              let categoryNames = field?.Artwork_Category?.map((item) => item.Category_Name).join(
                ", "
              );
              field.Artwork_Category_Store = [...field.Artwork_Category];
              field.Artwork_Category = categoryNames;
            }
 
            if (field.Artwork_Brand) {
              let brandName = field?.Artwork_Brand?.map((item) => item.Brand_Name).join(", ");
              field.Artwork_Brand_Store = [...field.Artwork_Brand];
              field.Artwork_Brand = brandName;
            }
 
            return field;
          });
        }

        let filteredPegaDataJson = localStorage.getItem("columnWiseFilterData");
        const filteredPegaData = JSON.parse(filteredPegaDataJson);
        
        if (filteredPegaData && filteredPegaData.length) {
          setFilters(filteredPegaData);
          setSelectedFields(filteredPegaData);
          setPegaData(ProjectData);
        } else {
          setPegaData(ProjectData);
        }

        //if (!initialPegaData || !initialPegaData?.length) {
          const initProjectData = _.cloneDeep(ProjectData);
          setInitialPegaData(initProjectData);
        //}

        // according to pathname we need to call api and store column name in local storage
        let columnNamesJson = localStorage.getItem("allColumnNames");
        let columnNames = JSON.parse(columnNamesJson);
        if (columnNames && columnNames?.length) {
          columnNames = AcpService?.removeCommonValues(columnNames, frozenCoulmns);
          columnNames = [...frozenCoulmns, ...columnNames];
          setProjectColumnNames(columnNames);
          setUpdatedAllColumnNames(columnNames);
        } else {
          let columnNames = ProjectService.getDSBPScreenColumnData();
          columnNames = AcpService?.removeCommonValues(columnNames, frozenCoulmns);
          columnNames = [...frozenCoulmns, ...columnNames];
          setUpdatedAllColumnNames(columnNames);
          setProjectColumnNames(columnNames);
          localStorage.setItem("allColumnNames", JSON.stringify(columnNames));
        }

        // get sort data from local storage and add in state
        let jsonSortingData1 = localStorage.getItem("sortingData");
        const sortingData = JSON.parse(jsonSortingData1);

        if (sortingData && sortingData.length) {
          const sortedData = onSortData(sortingData[0], sortingData[1], ProjectData);
          setPegaData(sortedData);
          setSortData([sortingData[0], sortingData[1]]);
        }
      } catch (err) {
        console.log("error", err);
      }
    })();
    setLoader(false);
  }, [DSBPScreenList]);

  const onSearchClick = () => {
    isSearchSet(!isSearch);
  };

  const addFrozenColumns = (name) => {
    if (!frozenCoulmns.includes(name)) {
      frozenCoulmns.push(name);
    } else {
      let columnIndex = frozenCoulmns.indexOf(name);
      frozenCoulmns.splice(columnIndex, 1);
    }
    setFrozenColumn(frozenCoulmns);
    const arr = getCustomizedView(true);
    setCustomizeViewFields(arr);
    localStorage.setItem("customizeViewFieldsDSBPScreen", JSON.stringify(arr));
  };

  const reorderColumns = (columns) => {
    const requiredColumnOrderArray = [
      "DSBP_Initiative_Name",
      "Category",
      "ProjectName",
      "DSBP_InitiativeID",
      "CountOfPOAs",
      "CountOfLockedPMPs",
      "Artwork_Category",
      "BU",
      "DSBP_PMP_ArtworkDate",
      "DSBP_IL",
      "Region",
      "CountOfPMPs",
      "Artwork_Brand",
      "AWMProjectID",
      "CountOfUnlockedPMPs",
      "PM",
    ];

    let reorderedColumns = [];
    requiredColumnOrderArray.forEach((rcl) => {
      columns.forEach((cl) => {
        if (rcl === cl) {
          reorderedColumns.push(cl);
        }
      });
    });
    return reorderedColumns;
  };

  const projectNameOnClick = (e, options) => {
    op.current.toggle(e);
    setSelectedColumnName(options);
  };

  const sortDataSet = (column, direction, data) => {
    const sortedData = filters?.length ? filters : pegadata;
    const sortedDataSet = AcpService.sortDataFirstStringThenNumeric(sortedData, column, direction);
    setSortData([column, direction]);
  };

  const onSort = (column, direction, filterData) => {
    const sortedData = filterData?.length? filterData : filters?.length ? filters : pegadata;
    const sortedDataSet = AcpService.sortDataFirstStringThenNumeric(sortedData, column, direction);

    setSortData([column, direction]);
    localStorage.setItem("sortingData", JSON.stringify(true));
    if (filterData?.length || filters?.length) {
      setFilters(sortedDataSet);
      selectedColumnList.current = sortedDataSet;
    }else{
      setPegaData(sortedDataSet);
    }
  };

  const showCategory = (options) => {
  let categoryNames = options["Artwork_Category"]?.map((item) => item.Category_Name).join(", ");
    return categoryNames;
  }

  const showBrand = (options) => {
    let brandNames = options["Artwork_Brand"]?.map((item) => item.Brand_Name).join(", ");
    return brandNames;
  }

  const showProjectId = (options) => {
    let AWMProjectID = options["AWMProjectID"];

    if (AWMProjectID === "") {
      return (
        <span className="d-flex">
          <button
            type="button"
            className="btn btn-primary btn-sm btn-sml"
            onClick={() => handleCreateProjectClick(options)}
          >
            Create a project
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm btn-sml ms-2"
            onClick={() => {
              props.setInitiativeId(options?.DSBP_InitiativeID);
              props.setInitiativeName(options?.DSBP_Initiative_Name);
              props.setAddToProjectPopUpStatus(true);
            }}
          >
            Add to existing project
          </button>
        </span>
      );
    }

    return (
      <span
        className="projectId"
        onClick={() => {
          dispatch(SpecialProjectAction(options?.SpecialProject));
          if (options?.SpecialProject === "Yes") {
            navigate(`/allProjects/artworkStatus/${AWMProjectID}`);
          } else {
            navigate(
              `/allProjects/${
                options?.Action === "Active" ? "projectPlan" : "projectSetup"
              }/${AWMProjectID}`
            );
          }
        }}
      >
        {AWMProjectID}
      </span>
    );
  };

  const fullKitReadinessBody = (options, rowData) => {
    let field = rowData.field;
    return (
      <>
        {field === "AWMProjectID" && showProjectId(options)}

        {field === "CountOfLockedPMPs" && <span title={options[field]}>{options["CountOfLockedPMPs"] + " / " + options["CountOfPMPs"]}</span>}

        {field === "CountOfPOAs" && <span title={options[field]}>{options["CountOfPOAs"] + " / " + options["CountOfPMPs"]}</span>}
        
        {field === "DSBP_PMP_ArtworkDate" && (
          <span title={options[field]}>{changeDateFormat(formatPayloadDate(DSBPConvertDateFormat(options[field])))}</span>
        )}

        {field !== "CountOfLockedPMPs" &&
          field !== "CountOfPOAs" &&
          field !== "AWMProjectID" && 
          field !== "DSBP_PMP_ArtworkDate" && (
            <>
              {" "}
              <span title={options[field]}>{options[field]}</span>
            </>
          )}

      </>
    );
  };

  
  const getUpdatedAllColumnFormat = (column) => {
    const finalData = column.map((el) => {
      return {
        width: 250,
        Sequence: "",
        freeze: false,
        Field_Name: el,
        reorder: false,
        Column_Name: el,
        sortAtoZ: false,
        sortZtoA: false,
        Attribute_Type: "Free Text",
      };
    });
    const data = getModifiedDSBPScreenHeaderNames(finalData);
    return data;
  };
  const onGlobalFilterChange = (e, colName) => {
    const { value, multiplesFlag, arr } = multiFilterChange(
      e,
      colName,
      selectedColumnName,
      selectedFields,
      setSelectedFields,
      pegadata,
      filterArray,
      selectedColumnList,
      colAllSelected,
      selectedFieldsRef
    );
    const _selectedFieldsRef =
      selectedFieldsRef?.current.length > 0 &&
      selectedFieldsRef?.current.map((el, i) => {
        if (Object.keys(arr)?.[0] === Object.keys(el)?.[0]) {
          return {
            ...el,
            [`${selectedColumnName}`]: arr[selectedColumnName],
          };
        } else {
          return el;
        }
      });
    if (AcpService.areAllPropertiesEmptyArrays(_selectedFieldsRef)) {
      localStorage.removeItem("_selectedFieldsRefCurrentDSBPScreen");
    }
    if (filterArray.current?.length) {
      const selectedColRes = _.uniqBy(colAllSelected?.current);
      if ((value?.length > 0 && !multiplesFlag) || selectedColRes?.length >= 1) {
        const _selectedFieldsRefWithoutEmptyArray =
          AcpService.removeEmptyArrays(_selectedFieldsRef);
        const filterData = AcpService.filterDataByfilters(
          pegadata,
          _selectedFieldsRefWithoutEmptyArray,
          setConditionMatched,
          "DSBPScreen"
        );
        const convertedObj = AcpCommonService.convertArrayToObject(
          _selectedFieldsRefWithoutEmptyArray
        );
        const uniqueObj = AcpCommonService.getUniqueValuesObject(convertedObj);
        setSelectedFields(uniqueObj);
        if (filterData?.length && sortData?.length) {
          onSort(sortData[0], sortData[1], filterData);
        } else {
          setFilters(filterData);
          selectedColumnList.current = filterData;
        }
      } else {
        selectedColumnList.current = [];
        selectedFieldsRef.current = [];
        setSelectedFields({});
        setFilters([]);
      }
    } else {
      selectedColumnList.current = [];
      selectedFieldsRef.current = [];
      setSelectedFields({});
      setFilters([]);
    }
  };

  const formCustomizeObject = (availableFields, freezedColumns, selectedFeilds) => {
    const customizeViewFieldsUpdated = {
      availableFields: {
        id: "availableFields",
        title: "Available Fields",
        fieldsData: availableFields,
      },
      freezedColumns: {
        id: "freezedColumns",
        title: "Freezed Fields",
        fieldsData: freezedColumns,
      },
      selectedFields: {
        id: "selectedFields",
        title: "Selected Fields",
        fieldsData: selectedFeilds,
      },
    };

    return customizeViewFieldsUpdated;
  };

  const getAvaiableFeilds = (customizeViewFields) => {
    const availableData = customizeViewFields?.availableFields?.fieldsData
    let availableDataList = []
    if (availableData?.length > 0) {
      availableData.map((item) => {
        const innerObj = {
          Field_Name: item
        }
        availableDataList.push(innerObj)
      })
      setAvailableFields(availableDataList)
    }
  }

  const setToInitialCustomizeView = async () => {
    let availableFields;
    const selectedFeildsVal = allColumnNamesConstValue
    availableFields = allColumnNames?.filter(function (objFromA) {
      return !allColumnNamesConstValue?.find(function (objFromB) {
        return objFromA === objFromB;
      });
    });

    let customizeViewColumnFromPega = await getColumnsOrder(userInformation?.userid, "customizeViewFieldsDSBPScreen", "NA", "NA");
    if (customizeViewColumnFromPega != null && customizeViewColumnFromPega != "") {
      setCustomizeViewFields(customizeViewColumnFromPega);
      getAvaiableFeilds(customizeViewColumnFromPega)
      localStorage.setItem("customizeViewFieldsDSBPScreen", JSON.stringify(customizeViewColumnFromPega));
    }
    else {
      const customizeViewFieldsUpdated = formCustomizeObject(availableFields, [], selectedFeildsVal);
      setCustomizeViewFields(customizeViewFieldsUpdated);
      localStorage.setItem("customizeViewFieldsDSBPScreen", JSON.stringify(customizeViewFieldsUpdated));
      await setColumnsOrder(userInformation?.userid, "customizeViewFieldsDSBPScreen", "NA", "NA", false, JSON.stringify(customizeViewFieldsUpdated));
    }
  };

  const getCustomizedView = (isFrozen) => {
    const selectedData = customizeViewFieldsStorage?.selectedFields?.fieldsData || [];
    const freezedData = customizeViewFieldsStorage?.freezedColumns?.fieldsData || [];
    const availableData = customizeViewFieldsStorage?.availableFields?.fieldsData || [];
    let availableFields;
    if (availableData?.length > 0) {
      availableFields = availableData;
    } else {
      let updatedColumnFinal = allColumnNames?.filter(function (objFromA) {
        return !projectColumnName.find(function (objFromB) {
          return objFromA === objFromB;
        });
      });
      const intermidaiteColumn = AcpService?.removeCommonValues(
        updatedColumnFinal,
        freezedData?.length ? freezedData : frozenCoulmns
      );
      const availableColumnToSelect = AcpService?.removeCommonValues(
        intermidaiteColumn,
        selectedData?.length ? selectedData : projectColumnName
      );
      availableFields = availableColumnToSelect?.length
        ? availableColumnToSelect
        : updatedColumnFinal;
    }

    const freezedColumns = isFrozen
      ? frozenCoulmns
      : freezedData?.length
        ? freezedData
        : frozenCoulmns;

    let selectedFields = selectedData?.length ? selectedData : projectColumnName;
    selectedFields = AcpService?.removeCommonValues(selectedFields, freezedColumns);

    const customizeViewFieldsUpdated = formCustomizeObject(
      availableFields,
      freezedColumns,
      selectedFields
    );

    const column = AcpService?.removeCommonValues(
      selectedFields,
      freezedData?.length ? freezedData : frozenCoulmns
    );
    const projectColumnNamesUpdated = freezedColumns.length > 0 ? [...freezedColumns, ...column] : selectedFields
    setProjectColumnNames(projectColumnNamesUpdated);
    if (!isFrozen) {
      setFrozenColumn(freezedColumns);
      setCustomizeViewFields(customizeViewFieldsUpdated);
    }
    return customizeViewFieldsUpdated;
  };

  const handleCustomizedView = async (data) => {
    if (data !== undefined && data?.length !== 0) {
      const parsedData = data?.selectedFields?.fieldsData?.length > 0
        ? data?.selectedFields?.fieldsData
        : data && JSON.parse(data);
      const freezedData = parsedData?.freezedColumns?.fieldsData || [];
      let selectedData = parsedData?.selectedFields?.fieldsData || [];
      localStorage.setItem("customizeViewFieldsDSBPScreen", JSON.stringify(parsedData));
      selectedData = AcpService?.removeCommonValues(selectedData, freezedData);
      await setColumnsOrder(userInformation?.userid, "customizeViewFieldsDSBPScreen", "NA", "NA", false, JSON.stringify(parsedData));
      selectedData = [...freezedData, ...selectedData];
      if (!checkIfOrderSame(ProjectService.getDSBPScreenColumnData(), selectedData)) {
        isCustomViewIsAddedDSBPScreen(true)
      } else {
        isCustomViewIsAddedDSBPScreen(false)
      }
      //enable reset button if selected feilds order has cahnged
      setProjectColumnNames(selectedData);
      setCustomizeViewFields(parsedData);
      getAvaiableFeilds(parsedData)
      freezedData?.length > 0 && setFrozenColumn([...freezedData]);
      freezedData?.length == 0 && setFrozenColumn([]); //when you drag from frozen to selected reset the state
    }
  };

  const storeReorderedColumns = (e) => {
    const dragColumnName = projectColumnName[e?.dragIndex];
    const index = projectColumnName.indexOf(dragColumnName);
    if (index > -1) {
      setReorderedColumn(true);
      projectColumnName.splice(index, 1);
      projectColumnName.splice(e?.dropIndex, 0, dragColumnName);
    }
    localStorage.setItem("allColumnNames", JSON.stringify(projectColumnName));
    setProjectColumnNames(projectColumnName);
    setTableRender(false);
  };

  const onColumnResizeEnd = (event) => {
   
    localWidthStorage(event,"columnWidthDSBPScreen")
    localStorage.setItem("isColWidthSetDSBPScreen", JSON.stringify(true));
    setProjectColumnNames(projectColumnName);
    setFilterCleared(false);
    setTableRender(false);
    setColWidth(true);
    setVisible(false);
  };

  const clearColumnWiseFilter = () => {
    let _selectedColumnName = selectedColumnName;
    let jsonSortItem = localStorage.getItem("sortingData");
    const sortItem = JSON.parse(jsonSortItem);
    if (sortItem && sortItem.length && sortItem[0] === selectedColumnName) {
      localStorage.setItem("sortingData", JSON.stringify([]));
    }
    if (sortData && sortData?.length && sortData[0] === _selectedColumnName) {
      setSortData([]);
    }

    const selectedFields2 = _.cloneDeep(selectedFields);
    const _selectedFields = AcpService.emptyProperty(selectedFields2, _selectedColumnName);
    const __selectedFields = AcpCommonService.removeEmptyArraysWithNoData(_selectedFields);
    

    let data = [];
    if (Object.keys(__selectedFields)?.length) {
      data = [...(pegadata || [])];
      Object.keys(__selectedFields).forEach((el) => {
        if (__selectedFields[el]?.length) {
          data = data.filter((ele) => __selectedFields[el].includes(ele[el]));
        }
      });
    }
    
    if (data?.length && Object.keys(__selectedFields)?.length) {
      setFilters(data);
    } else if (sortData?.length && sortData[0] !== _selectedColumnName) {
      selectedColumnList.current = pegadata;
      setFilters([]);
      onSort(sortData[0], sortData[1], pegadata);
    } else {
      setFilters([]);
      const finalInitialData = _.cloneDeep(initialPegaData);
      selectedColumnList.current = finalInitialData;
      setPegaData(finalInitialData);
    }
    setConditionMatched(false);
    selectedFieldsRef.current = __selectedFields;
    setSelectedFields(__selectedFields);
    if (AcpService.areAllPropertiesEmptyArrays(__selectedFields)) {
      localStorage.removeItem("_selectedFieldsRefCurrentDSBPScreen");
    }
  };

  const [resetKey, setResetKey] = useState(0);

  const handleChildClick = (isClicked) => {
    if (!isClicked) {
      clearFilter();
    }
  };
  const dynamicColumns = () => {
    if (projectColumnName?.length > 0) {
      return projectColumnName?.map((ele, i) => {
        let jsonColumnWidthDSBPScreen = localStorage.getItem("columnWidthDSBPScreen");
        const columnWidthDSBPScreen = JSON.parse(jsonColumnWidthDSBPScreen);
        let checkWidth = [];
        if (columnWidthDSBPScreen) {
          checkWidth = Object.keys(columnWidthDSBPScreen);
        }
        
        return (
          <Column
            filter
            key={ele}
            field={ele}
            filterField={ele}
            alignFrozen="left"
            columnKey={ele || i}
            showFilterMenu={false}
            filterPlaceholder={ele}
            body={fullKitReadinessBody}
            frozen={frozenCoulmns.includes(ele)}
            // {... checkWidth.includes(ele) && }
            className={frozenCoulmns.includes(ele) ? "font-bold frozen-width" : ""}
            header={DSBPScreenNameHeader(
              ele,
              frozenCoulmns,
              sortData,
              projectNameOnClick,
              selectedFields
            )}
            style={{
              width: projectColumnName?.includes(ele) && columnWidthDSBPScreen
                ? columnWidthDSBPScreen[ele]
                : "auto",
              maxWidth: projectColumnName?.includes(ele) && columnWidthDSBPScreen
                ? columnWidthDSBPScreen[ele]
                : "auto"
            }}
          />
        );
      });
    }
  };

  const clearFilters = () => {
    let allCol = [];
    const ProjectData = _.cloneDeep(DSBPScreenList);
    if (ProjectData.length) {
      allCol = Object.keys(ProjectData[0]);
      allCol.push("Artwork_Status");
    }
    localStorage.setItem("columnWiseFilterData", JSON.stringify({}));

    setPegaData(initialPegaData);
    setFilterCleared(true);
    setSelectedFields({});
    isSearchSet(false);
    setVisible(false);
    setFilters([]);
    setResizeMode("expand");
  };
  const clearFiltersResetToDefault = async (param) => {
    setLoader(true)
    clearFilters();
    isCustomViewIsAddedDSBPScreen(false)
    await clearFiltersResetToPG(param)
    setLoader(false)
  }

  const clearFiltersResetToPG = async (param) => {
    setLoader(true)
    localStorage.setItem("customizeViewFieldsDSBPScreen", JSON.stringify({}));
    await setColumnsOrder(userInformation?.userid, "customizeViewFieldsDSBPScreen", "NA", "NA", true, "");
    await setColumnsOrder(userInformation?.userid, "DSBPScreenAllColumnNames", "NA", "NA", true, "");
    setProjectColumnNames(allColumnNamesConstValue);
    await setToInitialCustomizeView()
    setFrozenColumn([]);
    isCustomViewIsAddedDSBPScreen(false);
    if(param==="globalReset"){
    setSortData([]);
    localStorage.removeItem("sortedColumn");
    localStorage.removeItem("columnWidthDSBPScreen");
    localStorage.removeItem("isColWidthSetDSBPScreen");
    }
    setResetKey((prev) => prev + 1);
    setLoader(false)
  }
  const saveSettings = () => {
    localStorage.setItem("sortingData", JSON.stringify(sortData));
    localStorage.setItem("frozenData", JSON.stringify(frozenCoulmns));
    localStorage.setItem("columnWiseFilterData", JSON.stringify(filters));
    localStorage.setItem("allColumnNames", JSON.stringify(projectColumnName));
  };

  const clearFilter = () => {
    setPegaData(initialPegaData);
    setSelectedFields({});
    isSearchSet(false);
    setFilters([]);
    selectedFieldsRef.current = [];
    if(sortData?.length){
      onSort(sortData[0], sortData[1], initialPegaData);
    }
  }; 
  return (
    <>
      <Toast ref={toast} position="top-right" />
      <div className="DSBPScreenList">
        {/* <Suspense fallback={ <Loading />}> */}
        <LoadingOverlay active={loader || loading || pegadata === null} spinner text="">
            {pegadata !== undefined && (
              <DSBPScreenHeader
                filterFLag={false}
                allData={pegadata}
                header={props.header}
                setVisible={setVisible}
                isTreeTableFlag={false}
                // exportCSV={exportCSV}
                headers={projectColumnName}
                CustomizeViewFlag={false}
                clearFilter={clearFilter}
                ResetToDefaultFlag={false}
                clearFilters={clearFilters}
                saveSettings={saveSettings}
                filename="DSBPScreen_Records"
                onSearchClick={onSearchClick}
                isResetEnabled={isResetEnabled}
                isFilterEnabled={isFilterEnabled}
                onGlobalFilterKeyword={onGlobalFilterKeyword}
                selected={filters}
                selectedFields={selectedFields}
                frozenCoulmns={frozenCoulmns}
                sortData={sortData}
                onChildClick={handleChildClick}
                clearFiltersResetToDefault={clearFiltersResetToDefault}
                validBu={props?.validBu}
                buRegionList={props?.buRegionList}
                buRegionValue={props?.buRegionValue}
                setBuRegionValue={props?.setBuRegionValue}
                allocation={props.allocation}
                setAllocation={props.setAllocation}
              />
            )}
            <CustomizeView
              availableFields={availableFields || []}
              showTaskDialog={visible}
              headerName={"DSBPScreen"}
              onClose={() => setVisible(false)}
              customizeViewFields={customizeViewFields}
              setCustomizeViewFields={handleCustomizedView}
              resetToPgDefault={clearFiltersResetToPG}
              allColumns={getUpdatedAllColumnFormat(allColumnNames)}
              setResetKey={setResetKey}
              pgDefaultColumns = {pgDefaultColumns}
            />

            <ACPFilter
              op={op}
              onSort={onSort}
              pageName={flag}
              filters={filters}
              sortData={sortData}
              setFilters={setFilters}
              tableRender={tableRender}
              setSortData={setSortData}
              saveSettings={saveSettings}
              ProjectFrozen={ProjectFrozen}
              frozenCoulmns={[]}
              selectedFields={selectedFields}
              setTableRender={setTableRender}
              setFrozenColumn={setFrozenColumn}
              setProjectFrozen={setProjectFrozen}
              addFrozenColumns={addFrozenColumns}
              projectColumnName={projectColumnName}
              isReorderedColumn={isReorderedColumn}
              selectedColumnName={selectedColumnName}
              setReorderedColumn={setReorderedColumn}
              onGlobalFilterChange={onGlobalFilterChange}
              setProjectColumnNames={setProjectColumnNames}
              setSelectedColumnName={setSelectedColumnName}
              clearColumnWiseFilter={clearColumnWiseFilter}
              // acpBookingFrozenColumn={acpBookingFrozenColumn}
              projectData={pegadata}
            />

            <DataTable
              ref={dt}
              scrollable
              resizableColumns
              className="mt-3"
              reorderableColumns
              dataKey="Project_ID"
              filters={searchHeader}
              responsiveLayout="scroll"
              columnResizeMode="expand"
              filterDisplay={isSearch && "row"}
              onColReorder={storeReorderedColumns}
              onColumnResizeEnd={onColumnResizeEnd}
              value={filters.length ? filters : pegadata}
              key={tableRender ? `"Project_ID" + timestamp+${resetKey}` : `${resetKey}`}
              emptyMessage={loader || loading || pegadata === null ? " " : "No records found"}
            // onValueChange={obj =>setFilteredData(obj)}
              tableStyle={{ width: "max-content", minWidth: "100%" }} 
               paginator={((filters.length ? filters : pegadata)?.length > 10) ? true : false}
               rows={20}             
               paginatorPosition="bottom"
            >
              {dynamicColumns()}
            </DataTable>
        </LoadingOverlay>
        {/* </Suspense> */}
      </div>

      {!loader && pegadata && (
        <Footer
          className="footer"
          totalObjects={filters?.length ? filters?.length : pegadata?.length}
          isSelected={false}
        />
      )}

      {visibleWarningCreateProject && (
          <DsbpCommonPopup
            actionHeader="Create Project"
            dasbpDialog={visibleWarningCreateProject}
            setDasbpDialog={setVisibleWarningCreateProject}
            onSubmit={handleCreateProject}
            poaaResponse={null}
            okButtonShow={false}
            deleteButtonShow={false}
            showCancel={false}
            submitButtonShow={true}
            yesButtonShow={false}
            disconnectButtonShow={true}
          >
            <p>
              DSBP Name: {DSBPCreateProjectData?.DSBP_Initiative_Name} <br/>
              DSBP ID: {DSBPCreateProjectData?.DSBP_InitiativeID}
            </p>
            <p>
              Are you sure you want to create a project and assign DSBP ID?
            </p>
          </DsbpCommonPopup>
        )}

    </>
  );
};
export default DSBPScreenList;
